module.exports = __webpack_public_path__ + "img/BOWTIE 1 LIME.116ce4b.svg";